import React from 'react'
import { ArrowDown } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { Illustration } from './Illustration'
import styles from './styles.module.css'

const literals = {
  build: {
    key: 'task_creation_build_step_by_step',
    fallback: { en: 'Build your task step by step', he: 'בנו את המשימה צעד אחר צעד' },
  },
  pick: {
    key: 'task_creation_pick_type_below',
    fallback: { en: 'Pick any subtask type in the bar below', he: 'בחרו סוג תת־משימה בסרגל למטה' },
  },
  settings: {
    key: 'task_creation_settings_placeholder',
    fallback: { en: 'Subtask settings will appear here', he: 'הגדרות תת־המשימה יופיעו כאן' },
  },
  first: {
    key: 'task_creation_settings_placeholder_hint',
    fallback: {
      en: 'Once you add a subtask, you’ll be able to set it up in this panel.',
      he: 'לאחר הוספת תת־משימה תוכלו להגדיר אותה בחלונית הזו.',
    },
  },
  select: {
    key: 'task_creation_select_to_edit',
    fallback: { en: 'Select a subtask to view its settings', he: 'בחרו תת־משימה כדי לראות את ההגדרות שלה' },
  },
  existing: {
    key: 'task_creation_select_or_add_hint',
    fallback: {
      en: 'Choose a subtask on the left, or add a new one from the bar below.',
      he: 'בחרו תת־משימה ברשימה, או הוסיפו חדשה מהסרגל למטה.',
    },
  },
}

interface ISubtaskBuilderEmptyStateProps {
  variant: 'list' | 'editor'
  showHint?: boolean
  hasSubtasks?: boolean
  taskName?: React.ReactNode
}

export function SubtaskBuilderEmptyState({
  variant,
  hasSubtasks = false,
  showHint = true,
  taskName,
}: ISubtaskBuilderEmptyStateProps) {
  const t = useLocaleText(literals)
  const editor = variant === 'editor'

  return (
    <div className={`${styles.empty} ${editor ? styles.editor : styles.list} ${taskName ? styles.onboarding : ''}`}>
      <div className={editor ? styles.message : styles.callout}>
        <strong>{editor ? (hasSubtasks ? t.select : t.settings) : t.build}</strong>
        {!editor && taskName ? (
          <>
            <div className={styles.nameStep}>
              <span className={styles.number} aria-hidden="true">
                1
              </span>
              {taskName}
            </div>
            <div className={styles.pickStep}>
              <span className={styles.number} aria-hidden="true">
                2
              </span>
              <span>{t.pick}</span>
              <ArrowDown size={16} aria-hidden="true" />
            </div>
          </>
        ) : (
          <>
            {showHint && <p>{editor ? (hasSubtasks ? t.existing : t.first) : t.pick}</p>}
            {!editor && <ArrowDown size={16} aria-hidden="true" />}
          </>
        )}
      </div>
      <Illustration editor={editor} />
    </div>
  )
}
